<template>
  <v-content class="login">
    <!-- logo -->
    <v-row align-content="center" justify="center" no-gutters class="logo">
      <img :src="init.top_logo_image" height="50px" style="width:auto; max-width:100%;" />
    </v-row>

    <div class="px-3 mt-10">
      <v-row class="">
        <v-col cols="12" sm="6" class="pb-0">
          <p class="subtitle-2 font-weight-black ma-0">ログインID（メールアドレス）</p>
          <v-text-field v-model="id" label single-line outlined dense></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0">
          <p class="subtitle-2 font-weight-black ma-0">パスワード</p>
          <v-text-field v-model="password" single-line outlined dense :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'" @click:append="show = !show"></v-text-field>
        </v-col>
      </v-row>

      <v-row class="caption">
        <v-col cols="6">
          <v-checkbox v-model="checkbox" :label="`ログイン情報を保存する`" class="fontsize11 ma-0 pa-0"></v-checkbox>
        </v-col>
        <v-col cols="6" class="text-right">
          <router-link to="/login/lost">パスワードをお忘れの方</router-link>
        </v-col>
      </v-row>

      <div class="text-center">
        <v-btn rounded class="maincolor-bg default_button" @click.stop="login()" :disabled="btnDisabledFlg">ログイン</v-btn>
      </div>

      <v-divider class="my-5"></v-divider>

      <div class="text-center">
        <p class="text-center ma-1 subtitle-2 font-weight-black">アカウントをお持ちでない方は</p>
        <v-btn rounded class="maincolor-btn2 default_button" to="regist">新規登録</v-btn>
      </div>

      <!-- MOPログイン前URL -->
      <div class="text-center subtitle-2 mt-4" v-if="init.shop_external_url">
        <p class="alink" @click.stop="toExternalurl">ログインせずに商品を見る場合はこちら</p>
      </div>

      <div class="text-center caption pt-10">
        <p class="">本アプリをご利用の際には、<router-link to="/info/rule">利用規約</router-link>をご確認ください。</p>
        <p class=""><router-link to="/info/legal">特定商取引法に基づく表記</router-link></p>
        <p class="caption" v-if="init.inquiry_mail">
          <v-icon>far fa-envelope</v-icon> <a :href="'mailto:'+init.inquiry_mail">お問い合わせ</a>
        </p>
      </div>

      <p class="text-center" v-if="init.copyright" style="font-size: 12px; margin-top:60px;">© {{init.copyright}} All right reserved.</p>

    </div>

    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
    </v-overlay>

  </v-content>
</template>

<script>
export default {
  data() {
    return {
      id: null,
      password: "",
      show: false,
      checkbox: true,
      init: [],
      routing: [],
      result: [],
      userregist: [],
      login_keep_flg: 1,
      loading: false,
      btnDisabledFlg: false
    };
  },
  mounted () {
    this.init = this.storageGet('*')
    if(this.init.login_id && this.init.password){
      const decryptedText = this.CryptoJS.AES.decrypt(this.init.password, this.init.login_id).toString(this.CryptoJS.enc.Utf8)
      this.id = this.init.login_id
      this.password = decryptedText
    }
  },
  watch: { //init apiが読み込まれたか監視
    '$root.init_flg': 'fetchData',
  },
  methods: {
    fetchData(){ //init apiが読み込まれた場合initに値を入れる
      this.storageSave(JSON.stringify({
        'registration_id': this.getUrlGetParam('registration_id'),
      }));
      this.init = this.storageGet('*');
    },
    toExternalurl(){
        //loadingを表示
        this.loading = true
        var tonative_req = {
            'destination': this.init.shop_external_url,
            'feature_id': 1,
            'screen_id': "top",
            'transition_type': 2,
            'transition_info': 'shopExternalurl',
            'page_title': this.init.shop_name,
          };

        if (!(this.screenTransition(tonative_req))) {
          // 遷移失敗・遷移情報が変な時もエラー表示があった方が良い？
          this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
        }
        // 処理の最後にローディングを終了させる
        this.loading = false
    },
    async login() {
      // 多重処理防止
      if (this.btnDisabledFlg) return

      try {
        //スピナー表示, ボタンdisabled
        this.loading = true
        this.btnDisabledFlg = true
        
        //念の為もう一度ローカルから取得（後ほど処理変える）
        this.init = this.storageGet('*')
        // ログインAPI実行
        var login_req = {'sid': this.init.sid, 'service_cd': this.init.service_cd, 'login_id': this.id, 'password': this.password }
        var res = await this.apiCall('/login', login_req, 'post', 2);
        if (!res) return false
        this.$set(this, 'result', res);
        
        //console.log(this.result)
        // 認証エラーチェック
        if (!res.auth_id) throw "login error"

        //ログインAPIから取得したaccess_tokenをlocalstrageに保存
        this.storageSave(JSON.stringify({
          'access_token': res.access_token,
          'refresh_token': res.refresh_token,
          'settlement_token': res.settlement_token,
        }))
        //console.log(res)
        //ログイン情報フラグを生成
        this.checkbox? this.login_keep_flg = 1 : this.login_keep_flg = 0

        //ログイン情報保持フラグありの場合、ログインIDとパスワードをlocalstorageに保存
        if(this.login_keep_flg == 1){
          const encryptedText = this.CryptoJS.AES.encrypt(this.password, this.id).toString()
          this.storageSave(JSON.stringify({
            'login_id': this.id,
            'password': encryptedText,
          }))
        }else{
          this.storageDelete('login_id')
          this.storageDelete('password')
        }

        /* user regist API実行 */
        var userregist_req = {
          'auth_id': res.auth_id,
          'device_uid': this.init.device_uid,
          'sid': this.init.sid,
          'key': this.init.key,
          'device_id': this.init.device_id,
          'os': this.init.os,
          'login_keep_flg': this.login_keep_flg
        };

        if(this.init.registration_id != "non_device_token") {
          userregist_req["registration_id"] = this.init.registration_id
        }

        var userregist_res = await this.apiCall('/user/regist', userregist_req, 'post');
        if (!userregist_res) return false

        this.$set(this, 'userregist', userregist_res)
        this.storageSave(JSON.stringify({
          'user_id': userregist_res.user_id,
          'user_name': userregist_res.user_name,
          'login_keep_flg': this.login_keep_flg,
          'device_uid': userregist_res.device_uid,
        }))
        //console.log(this.routing)

        /* ルーティングAPI実行 ※GETの場合は、paramsを設定する */
        var routing_req = { params: {
          'sid': this.init.sid,
          'device_uid': userregist_res.device_uid,
          'key': this.init.key,
          'device_id': this.init.device_id,
          'os': this.init.os,
          'feature_id': 'top',
          'service_cd': this.init.service_cd
        }};
        var routing_res = await this.apiCall('/user/routing', routing_req, 'get');
        if (!routing_res) {
          return false
        }
        this.$set(this, 'routing', routing_res);

        var tonative_req = {
            'Access-Token': this.result.access_token,
            'Refresh-Token': this.result.refresh_token,
            'Settlement-Token': this.result.settlement_token,
            'destination': this.routing.destination,
            'feature_id': this.routing.feature_id,
            'screen_id': this.routing.screen_id,
            'transition_type': this.routing.transition_type,
            'user_id': this.userregist.user_id,
            'user_name': this.userregist.user_name,
            'device_uid': this.userregist.device_uid,
          };

        if (!(this.screenTransition(tonative_req))) {
          // 遷移失敗・遷移情報が変な時もエラー表示があった方が良い？
          this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
        }
      } catch(e) {
        this.callDialog('ログインエラー', 'ログインID（メールアドレス）もしくはパスワードを確認してください。', 3);
      } finally {
        // 正常, 異常に関わらず処理完了時はスピナー, ボタンdisabled解除
        this.loading = false
        this.btnDisabledFlg = false
      }
    },
  }
};
</script>

<style scoped>
.fontsize11>>>label {
  font-size: 11px;
}

a {
  color: #333333;
}

.alink {
  color: #1976d2;
  text-decoration: underline;
}
</style>
